// react-query key roots for the tag domain.
export const tagQueryKeys = {
  tag: 'TAG',
  tagExists: 'TAG_EXISTS',
  tagsByDocument: 'TAGS_BY_DOCUMENT',
  tagsByDocumentPaginated: 'TAGS_BY_DOCUMENT_PAGINATED',
  tagsByElement: 'TAGS_BY_ELEMENT',
} as const;
